export default __webpack_public_path__ + "static/media/100_45656.a529d126.jpg";